// Start: AM Dr.Mek Page
const BASE_AM_DRMEK_ADMIN = [
  'AM_Charnapass',
  'AM_Phatcharee',
  'AM_Saymai',
  'AM_Sirinun',
  'AM_Supamit',
  'AM_Pornsook',
  'AM_Varaporn',
  'AM_Thitichayan',
  'AM_Suwicha',
  'AM_THEERAWAT',
  'AM_Anchalee',
  'AM_Sujitra',
  'AM_SATREERAT',
  'AM_Monthira',
  'AM_Pattrawan',
  'AM_Rattiyakorn',
  'AM_Nattawadee',
  'AM_Mooktida',
  'AM_Nattida',
  'AM_Peramin',
  'AM_Pornpimol',
  'AM_Duangkamon',
  'AM_Pattarakorn',
  'AM_Tanyaporn',
  'AM_Sirorat',
  'AM_Kanokwan',
  'AM_Wiyada',
  'AM_Chananchida',
  'AM_Admin1',
  'AM_Admin2',
  'adminfourth'
]

export const AM_DRMEK_ALL_IN_ONE_CHAT_MANAGE = {
  1277842645636317: [...BASE_AM_DRMEK_ADMIN],
  381410605695545: [...BASE_AM_DRMEK_ADMIN],
  119890184543994: [...BASE_AM_DRMEK_ADMIN],
  1725253494933: [
    ...BASE_AM_DRMEK_ADMIN,
    'AM_Tanaporn',
    'AM_Hattaya',
    'AM_Pariya',
    'AM_Nattawaran',
    'AM_Khanitta',
    'AM_Mookkarin',
    'AM_Praewa',
    'AM_Chonlada',
    'AM_Intuon',
    'AM_Neeracha',
    'AM_Chananchida',
    'AM_Sawitri',
    'AM_Suphattra',
    'AM_Wareerin'
  ],
  494749113725103: [...BASE_AM_DRMEK_ADMIN],
  412654801925444: [...BASE_AM_DRMEK_ADMIN],
  188631367666698: [...BASE_AM_DRMEK_ADMIN],
  107456345423163: [...BASE_AM_DRMEK_ADMIN],
  262363266951438: [...BASE_AM_DRMEK_ADMIN],
  105830898813837: [...BASE_AM_DRMEK_ADMIN],
  103579235797438: [...BASE_AM_DRMEK_ADMIN],
  104592089275353: [...BASE_AM_DRMEK_ADMIN],
  733448656529251: ['AM_Naiyana']
}
// End: AM Dr.Mek Page



// WEBPACK FOOTER //
// ./src/constants/access-menu.js